'use strict';


import { EnvironmentLayer } from './EnvironmentLayer';

export class RailwayEnvironment extends EnvironmentLayer{
    constructor () {
        super('Railway');
        this.animateCamera = true;
    }

    create() {
        this.objects.forEach(obj => {
            this.createLabel(obj);
            this.buildRoute(obj);
        });
    }

    show() {
        super.show();
        EnvironmentLayer.animateCameraShow();
    }

    hide() {
        super.hide();
        EnvironmentLayer.animateCameraHide();
    }

}